import { createSlice } from '@reduxjs/toolkit'

const initialState = {

}

export const pdfDataSlice = createSlice({
  name: 'pdf_data',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setPdfData: (state, action) => {
      Object.assign(state, action.payload)
    },
    initializePdfData: state => {
      Object.keys(state).forEach(key => {
        delete state[key]
      })
      Object.assign(state, initialState)
    },

  }
})

export const {
  setPdfData,
  initializePdfData
} = pdfDataSlice.actions

export default pdfDataSlice.reducer
